exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Gifabsolute[data-v-448447a4]{position:absolute;z-index:-99;left:-266.64rem;top:-2666.64rem}.Gifabsolute img[data-v-448447a4]{display:block;width:2.66667rem;height:2.66667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-448447a4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/report/Gifabsolute.vue
// module id = 1+J/
// module chunks = 56